<template>
  <b-container class="container--max-810 mt-6">
    <b-card title="User Information" border-variant="Primary" class="text-center">
      <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
        <!-- Basic Information -->
        <b-form-group :label="$t('lang.label_registration_firstName')" label-for="input-first-name" label-cols-sm="5">
          <label v-if="!isEdit" class="text-color">{{ userDetails.firstName }}</label>
          <b-form-input v-else id="input-first-name" v-model="userDetails.firstName"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('lang.label_registration_lastName')" label-for="input-last-name" label-cols-sm="5">
          <label v-if="!isEdit" class="text-color">{{ userDetails.lastName }}</label>
          <b-form-input v-else id="input-last-name" v-model="userDetails.lastName"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('lang.label_registration_orgName')" label-for="input-org-name" label-cols-sm="5">
          <label v-if="!isEdit" class="text-color">{{ userDetails.orgName }}</label>
          <b-form-input v-else id="input-org-name" v-model="userDetails.orgName"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('lang.label_registration_country')" label-for="input-country" label-cols-sm="5">
          <label v-if="!isEdit" class="text-color">{{ userDetails.country }}</label>
          <b-form-input v-else id="input-org-name" v-model="userDetails.country"></b-form-input>
        </b-form-group>
        <b-row>
          <b-col sm class="text-center mt-4">
            <b-button type="submit" variant="primary">{{ getButtonText }}</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm>
            <b-button variant="link" v-b-modal.modal-change-password>{{ $t("lang.label_password_change") }}</b-button>
          </b-col>
          <b-col sm>
            <b-button variant="link" @click="deleteAccount()">{{ $t("lang.label_delete_account") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-modal id="modal-change-password" title="Change Password" centered header-border-variant="light" hide-footer>
      <change-password-after-login></change-password-after-login>
    </b-modal>
    <user-email-update v-if="userDetails.email" :email="userDetails.email"></user-email-update>
  </b-container>
</template>
<script>
import API from "@/api";
import ChangePasswordAfterLogin from "../components/ChangePasswordAfterLogin";
import UserEmailUpdate from "../components/UserEmailUpdate";
export default {
  name: "UserProfile",
  data() {
    return {
      userDetails: [],
      wasValidated: false,
      isEdit: false
    };
  },
  computed: {
    getButtonText() {
      return this.isEdit ? this.$t("lang.label_save") : this.$t("lang.label_edit");
    }
  },
  methods: {
    getAccountDetails() {
      this.$store.dispatch("startLoading");
      API.getAccountDetails()
        .then(response => {
          this.$store.dispatch("stopLoading");
          this.userDetails = response.data;
        })
        .catch(() => {
          this.$store.dispatch("stopLoading");
        });
    },
    onSubmit() {
      this.isEdit = !this.isEdit;
      if (!this.isEdit) this.editDetails();
    },
    editDetails() {
      this.$store.dispatch("startLoading");
      API.updateUserDetails(this.userDetails.firstName, this.userDetails.lastName, this.userDetails.orgName, this.userDetails.country)
        .then(response => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_update_details_success"));
          this.userDetails = response.data;
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          if (e.response.data.message === "Old Password is wrong.") {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_password_old_error_invalid"));
          } else {
            this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_update_details_error"));
          }
        });
    },
    deleteAccount() {
      this.$bvModal
        .msgBoxConfirm(this.$t("lang.message_user_account_delete_confirmation"))
        .then(value => {
          if (value) {
            this.$store.dispatch("auth/deleteOwnUserAccount").catch(() => {
              this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_user_account_deleted_error"));
            });
          }
        })
        .catch(() => {});
    }
  },
  components: {
    ChangePasswordAfterLogin,
    UserEmailUpdate
  },
  mounted() {
    this.getAccountDetails();
  }
};
</script>
<style>
.text-color {
  color: #7d7d7d !important;
  font-size: 1rem !important;
}
</style>
